export default class OfferCommentSerializer {
  static serialize(data) {
    return {
      ...data
    };
  }

  static deSerialize(data) {
    return {
      ...data
    };
  }
}